/**
 * Extended Banner – slideshow + YouTube/Vimeo background videos
 */
(function () {
  'use strict';

  function parseYouTubeId(url) {
    if (!url) return null;
    const match = url.match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  }

  function parseVimeoId(url) {
    if (!url) return null;
    const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : null;
  }

  function buildYouTubeSrc(id) {
    const params = new URLSearchParams({
      autoplay: '1',
      mute: '1',
      loop: '1',
      playlist: id,
      controls: '0',
      showinfo: '0',
      rel: '0',
      playsinline: '1',
      modestbranding: '1',
      iv_load_policy: '3',
    });
    return `https://www.youtube.com/embed/${id}?${params.toString()}`;
  }

  function buildVimeoSrc(id) {
    const params = new URLSearchParams({
      autoplay: '1',
      muted: '1',
      loop: '1',
      background: '1',
      transparent: '0',
      title: '0',
      byline: '0',
      portrait: '0',
    });
    return `https://player.vimeo.com/video/${id}?${params.toString()}`;
  }

  function pauseSlideMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach((video) => {
      video.pause();
    });
    slide.querySelectorAll('iframe').forEach((iframe) => {
      iframe.src = iframe.dataset.src || iframe.src;
    });
  }

  function playSlideMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach((video) => {
      video.muted = true;
      video.play().catch(() => {});
    });
    slide.querySelectorAll('iframe[data-src]').forEach((iframe) => {
      if (!iframe.src || iframe.src === 'about:blank') {
        iframe.src = iframe.dataset.src;
      }
    });
  }

  function initBanner(banner) {
    if (!banner || banner.dataset.ebInitialized === 'true') return;
    banner.dataset.ebInitialized = 'true';

    const slides = Array.from(banner.querySelectorAll('[data-eb-slide]'));
    const dots = Array.from(banner.querySelectorAll('[data-eb-dot]'));
    const prevBtn = banner.querySelector('[data-eb-prev]');
    const nextBtn = banner.querySelector('[data-eb-next]');
    const autoplay = banner.dataset.autoplay === 'true';
    const duration = (parseInt(banner.dataset.duration, 10) || 6) * 1000;

    if (slides.length === 0) return;

    let current = slides.findIndex((s) => s.classList.contains('is-active'));
    if (current < 0) current = 0;

    let timer = null;

    const goTo = (index) => {
      const next = (index + slides.length) % slides.length;
      if (next === current) return;

      pauseSlideMedia(slides[current]);
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');

      current = next;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
      playSlideMedia(slides[current]);
    };

    const next = () => goTo(current + 1);
    const prev = () => goTo(current - 1);

    const startAutoplay = () => {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(next, duration);
    };

    const stopAutoplay = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i);
        startAutoplay();
      });
    });

    prevBtn?.addEventListener('click', () => {
      prev();
      startAutoplay();
    });

    nextBtn?.addEventListener('click', () => {
      next();
      startAutoplay();
    });

    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);

    playSlideMedia(slides[current]);
    startAutoplay();

    banner._ebDestroy = () => {
      stopAutoplay();
      pauseSlideMedia(slides[current]);
    };
  }

  function initIframeSources(banner) {
    banner.querySelectorAll('[data-eb-youtube]').forEach((el) => {
      const id = parseYouTubeId(el.dataset.ebYoutube);
      if (!id) return;
      const iframe = el.querySelector('iframe');
      if (iframe) iframe.dataset.src = buildYouTubeSrc(id);
    });

    banner.querySelectorAll('[data-eb-vimeo]').forEach((el) => {
      const id = parseVimeoId(el.dataset.ebVimeo);
      if (!id) return;
      const iframe = el.querySelector('iframe');
      if (iframe) iframe.dataset.src = buildVimeoSrc(id);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-extended-banner]').forEach((banner) => {
      initIframeSources(banner);
      initBanner(banner);
    });
    document.dispatchEvent(new CustomEvent('extended-banner:loaded'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const banner = event.target.querySelector('[data-extended-banner]');
    if (banner) {
      initIframeSources(banner);
      initBanner(banner);
      document.dispatchEvent(new CustomEvent('extended-banner:loaded'));
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const banner = event.target.querySelector('[data-extended-banner]');
    if (banner?._ebDestroy) banner._ebDestroy();
  });
})();
(function () {
  'use strict';
  function addSwipe(banner) {
    if (!banner || banner.dataset.ebSwipe === 'true') return;
    var dots = Array.prototype.slice.call(banner.querySelectorAll('[data-eb-dot]'));
    if (dots.length < 2) return;

    var x0 = 0, y0 = 0, locked = null;

    banner.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
      locked = null;
    }, { passive: true });

    banner.addEventListener('touchmove', function (e) {
      if (locked !== null || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - x0;
      var dy = e.touches[0].clientY - y0;
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
        locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
    }, { passive: true });

    banner.addEventListener('touchend', function (e) {
      if (locked !== 'x') return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) < 45) return;
      var cur = dots.findIndex(function (d) { return d.classList.contains('is-active'); });
      if (cur < 0) cur = 0;
      var step = dx < 0 ? 1 : -1;
      var target = (cur + step + dots.length) % dots.length;
      dots[target].click();
    }, { passive: true });

    banner.style.touchAction = 'pan-y';
    banner.dataset.ebSwipe = 'true';
  }

  function initSwipeAll() {
    document.querySelectorAll('[data-extended-banner]').forEach(addSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipeAll);
  } else {
    initSwipeAll();
  }
  document.addEventListener('shopify:section:load', initSwipeAll);
})();